import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { formatApiErrorDetail } from "@/lib/api";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (e) {
      setErr(formatApiErrorDetail(e.response?.data?.detail) || e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="admin-shell flex items-center justify-center px-6 py-20">
      <div className="w-full max-w-md">
        <Link to="/" className="eyebrow-muted text-[11px] mb-10 inline-block">← Back to site</Link>
        <div className="font-display text-5xl mb-2" style={{ color: "var(--text-primary)" }}>Admin</div>
        <p className="text-sm mb-10" style={{ color: "var(--text-secondary)" }}>
          Sign in to manage sales, consignors, videos & content.
        </p>
        <form onSubmit={submit} className="space-y-5">
          <div>
            <label className="eyebrow-muted text-[10px] block mb-2">Email</label>
            <input
              data-testid="admin-email-input"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full h-12 px-4 bg-transparent border outline-none focus:border-[color:var(--brass)]"
              style={{ borderColor: "var(--border-subtle)", color: "var(--text-primary)" }}
            />
          </div>
          <div>
            <label className="eyebrow-muted text-[10px] block mb-2">Password</label>
            <input
              data-testid="admin-password-input"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full h-12 px-4 bg-transparent border outline-none focus:border-[color:var(--brass)]"
              style={{ borderColor: "var(--border-subtle)", color: "var(--text-primary)" }}
            />
          </div>
          {err && <div data-testid="admin-login-error" className="text-sm" style={{ color: "#E5807F" }}>{err}</div>}
          <button data-testid="admin-login-submit" type="submit" disabled={loading} className="btn-primary w-full">
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
